import React, {
  createContext,
  useContext,
  useLayoutEffect,
  useState,
} from 'react';
import { useLocation } from 'react-router-dom';
import { Context } from './types';

interface Props {
  children: React.ReactNode;
}

const KEY = 'followed-direct-link';

const FirstVisitContext = createContext<Context>({} as Context);

export function FirstVisitProvider({ children }: Props) {
  const location = useLocation();
  const [isFirstVisit, setIsFirstVisit] = useState<boolean>(false);

  useLayoutEffect(() => {
    const isFollowedDirectLinkItem = sessionStorage.getItem(KEY);

    if (!isFollowedDirectLinkItem) {
      setIsFirstVisit(true);
      sessionStorage.setItem(KEY, 'true');
    } else {
      setIsFirstVisit(false);
    }
  }, [location]);

  return (
    <FirstVisitContext.Provider
      value={{
        isFirstVisit,
      }}
    >
      {children}
    </FirstVisitContext.Provider>
  );
}

const useFirstVisitContext = () => useContext(FirstVisitContext);
export default useFirstVisitContext;
